import { render, staticRenderFns } from "./privacidadEU.vue?vue&type=template&id=f2902028&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "privacidadEU.vue"
export default component.exports